import ActionTypes from '../constants/action-types';
import { RootActionTypes } from '../../../stores/types';

export default function openExportExperienceSettingsModal(): RootActionTypes {
  return {
    type: ActionTypes.OPEN_EXPORT_EXPERIENCE_SETTINGS_MODAL,
  };
}
